export default function (context, val) {
    let form = context.rootState.finances.pay.form;
    let options = context.rootState.finances.pay.options;
    let system = context.rootState.finances.pay.system;
    let list = context.state.list;
    let Sum = form.Sum;
    if (!list.length && val.length === 1) {
        context.dispatch('get', {
            id: val[0].Id,
            callback: (regular) => {
                context.commit('finances/pay/set_form', regular.form, {root: true});
                if (Sum) context.commit('finances/pay/set_form', {Sum}, {root: true});
            }
        })
    } else if (!list.length) {
        let load = 0;
        val.forEach(i => {
            load++;
            context.dispatch('get', {
                id: i.Id,
                callback: (regular) => {
                    load--;
                    if (load) return;
                    context.commit('finances/pay/set_form', regular.form, {root: true});
                    if (!Sum) {
                        val.forEach(j => {
                            Sum += context.getters.regular(j.Id).form.Sum;
                        });
                    }
                    context.commit('finances/pay/set_form', {Sum}, {root: true});
                }
            });
        });
    } else {
        val.forEach(i => {
            context.dispatch('get', {
                id: i.Id,
                callback: (val) => {
                }
            });
        });
    }
}
